import { Injectable } from '@angular/core';
import { AbstractRestService } from 'src/app/shared/types/AbstractRestService';
import { HttpService } from '../http.service';
import { AppSettingsService } from '../app-settings.service';
import { BehaviorSubject, Observable, catchError, concat, of, shareReplay, switchMap, tap, throwError } from 'rxjs';
import { CompanyDetails } from 'src/app/dashboard/models/companyDetails.model';

@Injectable({
  providedIn: 'root'
})
export class CompanyMsService extends AbstractRestService<CompanyDetails, any> {
  protected readonly baseEndpoint$ = this.appSettingsService.localEnv ?
                                     of('https://localhost:44360/api/Company/') :
                                     of('Company/');

private _companies$ = new BehaviorSubject<CompanyDetails[]>(null)
public companies$ = concat(this.getCompanyDetails(), this._companies$).pipe(shareReplay(1));

  constructor(protected http: HttpService,
              private appSettingsService: AppSettingsService) {
    super(http);
  }

  public getCompanyDetails(): Observable<CompanyDetails[]> {
    return this.baseEndpoint$.pipe(
      switchMap(baseUrl => this.http.getTyped<CompanyDetails[]>(`${baseUrl}`)),
      tap(companies => this._companies$.next(companies)),
      catchError(err => 
        throwError(() => err)
      )
    );
  }

  public addCompanyDetails(company:CompanyDetails): Observable<CompanyDetails> {
    return this.baseEndpoint$.pipe(
      switchMap(baseUrl => this.http.postTyped<CompanyDetails>(`${baseUrl}`, company)),
      tap(com => this.addCompanyToList(com)),
      catchError(err => 
        throwError(() => err)
      )
    );
  }

  public updateCompanyDetails(company:CompanyDetails): Observable<CompanyDetails> {
    return this.baseEndpoint$.pipe(
      switchMap(baseUrl => this.http.putTyped<CompanyDetails>(`${baseUrl}`, company)),
      tap(com => this.updateCompanyInList(com)),
      catchError(err => 
        throwError(() => err)
      )
    );
  }

  private updateCompanyInList(company:CompanyDetails) {
    const companies = this._companies$.getValue();
    const ind = companies.findIndex((c) => c.id === company.id);
    if (ind > -1) {
      companies.splice(ind, 1, company);
    }
    this._companies$.next(companies);
  }

  private addCompanyToList(company:CompanyDetails) {
    const companies = this._companies$.getValue();
    companies.push(company);
    this._companies$.next(companies);
  }
}
